module.exports = __webpack_public_path__ + "img/1920_icon_homepage_taking.8e39be7f.svg";